module.exports = __webpack_public_path__ + "static/media/star-half.6ab15791.svg";